import { useMemo } from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';

import { createResourcePromptMenuItem, PROMPT_MENU_TYPE } from '../../lib';
import { BaseItemsList } from '../BaseItemsList';
import { MenuItem } from '../MenuItem';

import { useStyles } from './useStyles';

const propTypes = {
  className: PropTypes.string,
  resources: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  onAction: PropTypes.func.isRequired,
  quickSearchMode: PropTypes.bool,
  menuType: PropTypes.oneOf(Object.values(PROMPT_MENU_TYPE)).isRequired,
  noTags: PropTypes.bool,
};

const defaultProps = {
  className: '',
  quickSearchMode: false,
  noTags: false,
};

export const ItemsResource = ({
  className,
  resources,
  onAction,
  quickSearchMode,
  menuType,
  noTags,
}) => {
  const styles = useStyles();

  const menuItems = useMemo(() => (resources || []).map(createResourcePromptMenuItem), [resources]);

  return (
    <BaseItemsList className={cx(styles.root, className)}>
      {menuItems.map((item) => (
        <MenuItem
          key={item.id}
          type={menuType}
          item={item}
          onAction={onAction}
          menuType={menuType}
          quickSearchMode={quickSearchMode}
          noTags={noTags}
        />
      ))}
    </BaseItemsList>
  );
};

ItemsResource.displayName = 'ItemsResource';
ItemsResource.propTypes = propTypes;
ItemsResource.defaultProps = defaultProps;
